var fakeSocket = require('./fakesocket');

var definitions = {
  low: [],
  medium: [],
  high: []
};

var chaosocket = function chaosocket() {
  var isValidFrequency = function isValidFrequency(frequency) {
    return Object.keys(definitions).indexOf(frequency) > -1;
  };

  var register = function register(definition) {
    var frequency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'medium';

    if (!isValidFrequency(frequency)) {
      throw new Error("".concat(frequency, "\xA0is not a valid frequency"));
    }

    definitions[frequency].push(definition);
  };

  var listen = function listen(options) {
    fakeSocket.listen(definitions, options);
  };

  var close = function close() {
    fakeSocket.close();
  };

  return {
    register: register,
    listen: listen,
    close: close,
    FakeSocket: fakeSocket.FakeSocket
  };
};

module.exports = chaosocket();